import {AxiosResponse} from 'axios';
import {OrganisationsModel} from 'library/src/organisations/models/OrganisationsModel';
import api, {wagoNestApiUrl} from 'shared/services/ApiConfig';
import PixagriScopes from '../../../library/src/core/models/PixagriScopes';

export class PixagriOrganisationsApiService {
  getBaseUrl() {
    return `${wagoNestApiUrl}/${PixagriScopes.ORGANISATIONS}`;
  }

  getAllowedOrganisationsUrl() {
    let baseUrl = this.getBaseUrl();
    return baseUrl;
  }

  async getAllowedOrganisations(): Promise<OrganisationsModel[]> {
    const url = this.getAllowedOrganisationsUrl();
    const res: AxiosResponse<OrganisationsModel[]> = await api.get(url);
    return res.data;
  }
}

const pixagriOrganisationsApiService = new PixagriOrganisationsApiService();
export default pixagriOrganisationsApiService;
